import { ClaimFarmRewardsAction } from '../types'
import { stakingRewardsAbi } from '@/config/abis/stakingRewardsAbi'
import { getBalancesQueryKeyPrefix } from '@/domain/wallet/getBalancesQueryKeyPrefix'
import { ensureConfigTypes } from '@/features/actions/logic/transactions/useWrite'
import { ActionConfig, ActionContext } from '@/features/actions/logic/types'
import { spkFarmDataQueryKey } from '@/features/spk/farm/data/useSpkFarmData'

export function createClaimFarmRewardsActionConfig(
  action: ClaimFarmRewardsAction,
  context: ActionContext,
): ActionConfig {
  const { account, chainId } = context

  return {
    getWriteConfig: () => {
      return ensureConfigTypes({
        address: action.farm,
        abi: stakingRewardsAbi,
        functionName: 'getReward',
      })
    },

    invalidates: () => [spkFarmDataQueryKey({ account, chainId }), getBalancesQueryKeyPrefix({ chainId, account })],
  }
}
